import { LayaGL } from "../../layagl/LayaGL";
export class Scene2DSpecialManager {
    constructor() {
        this.componentElementMap = new Map();
        this._shaderData = LayaGL.renderDeviceFactory.createShaderData(null);
    }
}
